const getPuzzle = async (wordCount)=>{
    const response = await fetch(`//puzzle.mead.io/puzzle?wordCount=${wordCount}`,{})
    if(response.status===200){
        const data= await response.json()
        return data.puzzle
    }
    else{
        throw new Error('unable to fetch')//invoke the catch block
      }
}


const getCountryDetails= async (countryCode)=>{
    const response = await fetch('//restcountries.eu/rest/v2/all',{})
    if(response.status===200){

        const data= await response.json()
        return data.find((country)=>country.alpha2Code===countryCode)

    }
    else{
        throw new Error('invalid response')
    }
}



const getLocation=async ()=> {
    const response = await fetch('//ipinfo.io/json?token=a11387f8de31a1')
    if(response.status===200){
        return response.json()
        
    }
    else{
        throw new Error('invalid response')
    }
}

const getCurrentCountry= async ()=>{
    const location = await getLocation()
    return getCountryDetails(location.country)
    
    
}


export {getPuzzle as default}